// data/languages/Cote/categories/nourriture.ts

import { CategoryData } from '../../../../types/types';

export const nourriture: CategoryData = {
    // Bases alimentaires et boissons
    'ⲙⲟⲟⲩ (moou)': {
        translation: 'Eau',
        translationEn: 'Water',
        illustration: '💧'
    },
    'ⲱⲓⲕ (ôik)': {
        translation: 'Pain',
        translationEn: 'Bread',
        illustration: '🍞'
    },
    'ⲁϥ (af)': {
        translation: 'Viande',
        translationEn: 'Meat',
        illustration: '🥩'
    },
    'ⲧⲉⲃⲧ (tebt)': {
        translation: 'Poisson',
        translationEn: 'Fish',
        illustration: '🐠'
    },
    'ⲉⲣⲟⲧ (erot)': {
        translation: 'Lait', // Correction: La forme standard est 'erot', pas 'erôti'
        translationEn: 'Milk',
        illustration: '🥛'
    },
    'ⲁⲥⲕⲱⲗ (askôl)': {
        translation: 'Œuf', // Correction: Terme standard pour œuf
        translationEn: 'Egg',
        illustration: '🥚'
    },
    'ⲕⲁⲣⲡⲟⲥ (karpos)': {
        translation: 'Fruit',
        translationEn: 'Fruit',
        illustration: '🍎'
    },
    'ϩⲙⲟⲩ (hmou)': {
        translation: 'Sel',
        translationEn: 'Salt',
        illustration: '🧂'
    },

    // Aliments et ingrédients Cotes
    'ⲫⲁⲕⲟⲓ (fakoi)': {
        translation: 'Lentilles (plat de jeûne)', // Base de la soupe de lentilles égyptienne
        translationEn: 'Lentils (fasting dish)',
        illustration: '🍲'
    },
    'ⲧⲁⲃⲁⲥ (tabas)': {
        translation: 'Fèves / Haricots', // Base du Foul, plat national
        translationEn: 'Fava beans / Beans',
        illustration: '🫘'
    },

    'ⲛⲉϩ (neh)': {
        translation: 'Huile / Graisse (Végétale)', // Essentiel pour la cuisine de jeûne
        translationEn: 'Oil / Fat (vegetable)',
        illustration: '🍾'
    },
    'ⲥⲱⲃⲧ (sôbt)': {
        translation: 'Miel / Douceur',
        translationEn: 'Honey / Sweetness',
        illustration: '🍯'
    },
    'ⲃⲛⲛⲉ (bnne)': {
        translation: 'Dattes', // Fruit iconique de l'Égypte
        translationEn: 'Dates',
        illustration: '🌴'
    },

    // Boissons culturelles
    'ⲏⲣⲡ (êrp)': {
        translation: 'Vin', // Boisson sacramentelle
        translationEn: 'Wine',
        illustration: '🍷'
    },
    'ⲕⲁⲫⲉ (kaphe)': {
        translation: 'Café',
        translationEn: 'Coffee',
        illustration: '☕'
    },
    'ⲗⲁⲭⲁⲛⲟⲛ (lakhanon)': {
        translation: 'Légumes / Herbes', // Terme général pour les légumes
        translationEn: 'Vegetables / Herbs',
        illustration: '🥬'
    },
};

export default nourriture;
